// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a07ebf46","952":"097cb13e"}[chunkId] + ".chunk.js";
};